export function searchString(needle, haystack) {
  return haystack.toLowerCase().includes(needle.toLowerCase())
}
